import { NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-grid',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    RouterModule,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
    NgOptimizedImage,
  ],
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
})
export class GridComponent implements OnChanges {
  components: any;
  @Input() background: string = '';

  constructor(private el: ElementRef, private renderer: Renderer2) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  ngOnChanges(): void {
    this.renderer.setStyle(
      this.el.nativeElement,
      'background-color',
      this.background
    );
  }

  @Input() _uid!: string;
  @Input() component!: string;

  @Input() columns!: any[];
  @Input() _editable: any;
}
